module.exports = __webpack_public_path__ + "img/trusted.aa15075.svg";